export { VisitedNodes };
class VisitedNodes {
    constructor(nodes) {
        this.nodes = nodes;
    }
    visit({ fromWaypointId, toWaypointId, fromRadius, toRadius, fromAngle, toAngle }) {
        let from = this.nodes.get(fromWaypointId);
        if (from === undefined) {
            from = new Map();
            this.nodes.set(fromWaypointId, from);
        }
        let to = from.get(toWaypointId);
        if (to === undefined) {
            to = [];
            from.set(toWaypointId, to);
        }
        to.push({
            fromRadius,
            toRadius,
            fromAngle,
            toAngle
        });
    }
    visited({ fromWaypointId, toWaypointId, fromRadius, toRadius, fromAngle, toAngle }) {
        const from = this.nodes.get(fromWaypointId);
        if (from === undefined) {
            return false;
        }
        const to = from.get(toWaypointId);
        if (to === undefined) {
            return false;
        }
        return to.some(t => fromRadius === t.fromRadius && toRadius === t.toRadius && fromAngle === t.fromAngle && toAngle === t.toAngle);
    }
    static create() {
        return new VisitedNodes(new Map());
    }
}
//# sourceMappingURL=VisitedNodes.js.map